import Bowser from "bowser";

const browser = Bowser.getParser(window.navigator.userAgent);

export const isValidBrowser = browser.satisfies({
    chrome: ">=80",
    firefox: ">=73",
    safari: '>=13',
    ie: ">=11",
    edge: ">=80",
    opera: ">=67"
});

export const isValidBrowserForProceed = browser.satisfies({
    chrome: ">=65",
    firefox: ">=65",
    safari: '>=11',
    ie: ">=11",
    edge: ">=80",
    opera: ">=50"
});